import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';

export const LoadingPanel = ({ displayMessage, message, className }) => (
  <div className={`card-panel loading ${className}`}>
    <div className="fa-3x text-center">
      <FontAwesomeIcon icon={faCircleNotch} color="#0F6C9D" spin />
    </div>
    {displayMessage && <div className="loading-text">{message || 'Loading...'}</div>}
  </div>
);

LoadingPanel.propTypes = {
  message: PropTypes.string,
  displayMessage: PropTypes.bool,
  className: PropTypes.string,
};
LoadingPanel.defaultProps = {
  message: 'Loading...',
  displayMessage: true,
  className: '',
};
